export const PILLS = [
  {
    id: 1,
    hasLanding: true,
    alias: 'conoce-tu-perfil-inversor',
    title: 'Calcula tu perfil inversor',
    img: 'https://unienceproduction-images-dhnw29xkhb2o.s3.amazonaws.com/f4e00617595c0a239491bdf593a063c695d7d9b0653'
  },
  {
    id: 2,
    hasLanding: true,
    alias: 'cuanto-tendras-segun-riesgo-asumido',
    title: '¿Cuánto puedo ganar invirtiendo a largo plazo?',
    img: 'https://unienceproduction-images-dhnw29xkhb2o.s3.amazonaws.com/1fc16337d5cde9fcfe527a821604f87025cd778b23b'
  },
  {
    id: 3,
    hasLanding: true,
    isOld: true,
    alias: 'valor-ahorros-inflacion',
    title: '¿Cuánto valor perderán tus ahorros por la inflación?',
    img: 'https://finect.com/images/pills/valor-ahorros-inflacion/coverBkg.jpg'
  },
  {
    id: 4,
    hasLanding: true,
    alias: 'salud-financiera',
    title: 'Calculadora finanzas personales',
    img: 'https://www.finect.com/image/2330e4b836f06eade655dab52f94b68ecba72c84df6'
  },
  {
    id: 5,
    hasLanding: true,
    alias: 'calcula-tus-retenciones',
    title: 'Retención IRPF: ¿Cuánto te retiene Hacienda del sueldo?',
    img: 'https://www.finect.com/image/7b91ad39a0cb4bf5a55b150cbe0db6d5'
  },
  {
    id: 6,
    hasLanding: true,
    alias: 'calculadora-sueldo-neto',
    title: 'Calculadora de sueldo neto',
    img: 'https://www.finect.com/image/4baaf2d5dfc03e22a23d2655e2ad63b68f644222226'
  },
  // SIN LANDINGS
  // {
  //   id: 20,
  //   alias: 'amortizar-hipoteca-cuota-plazo',
  //   title: 'Quiero amortizar parte de mi hipoteca ¿reduzco las cuotas o el plazo?',
  //   img: 'https://www.finect.com/image/c7236e09245dc54446e2636170ebcbf6df2696fd334'
  // },
  {
    id: 22,
    alias: 'compro-o-alquilo',
    title: '¿Me interesa más comprar o alquilar?',
    img: 'https://www.finect.com/image/85705e7eb7db4b9a8632b5fcb16bcc1f'
  },
  {
    id: 23,
    alias: 'cuales-son-los-gastos-al-comprar-una-casa',
    title: '¿Cuáles son los gastos al comprar una casa?',
    img: 'https://www.finect.com/image/2f36342bca6f40b6979f78a898612719'
  },
  {
    id: 24,
    isOld: true,
    alias: 'cuanto-puedo-deducir-con-un-plan-de-pensiones',
    title: '¿Cuánto puedo deducir con un plan de pensiones?',
    img: 'https://finect.com/images/pills/cuanto-puedo-deducir-con-un-plan-de-pensiones/coverBkg.jpg'
  },
  {
    id: 25,
    isOld: true,
    alias: 'cuanto-rescatare-si-ahorro-cantidad-al-mes',
    title: '¿Cuánto podré rescatar si ahorro una cantidad todos los meses?',
    img: 'https://finect.com/images/pills/cuanto-rescatare-si-ahorro-cantidad-al-mes/coverBkg.jpg'
  },
  {
    id: 26,
    isOld: true,
    alias: 'gastos-constitucion-hipoteca',
    title: '¿Qué gastos tiene firmar mi hipoteca?',
    img: 'https://finect.com/images/pills/gastos-constitucion-hipoteca/coverBkg.jpg'
  },
  {
    id: 27,
    alias: 'hipoteca-tipo-fijo-o-tipo-variable',
    title: 'Hipoteca: ¿tipo fijo o tipo variable?',
    img: 'https://unienceproduction-images-dhnw29xkhb2o.s3.amazonaws.com/32590d6d0f7ba654debcf5fe9b5264a070a35fa7709'
  },
  {
    id: 28,
    isOld: true,
    alias: 'tengo-derecho-ayuda-vivienda',
    title: '¿Tengo derecho a la ayuda a la vivienda?',
    img: 'https://finect.com/images/pills/tengo-derecho-ayuda-vivienda/coverBkg.jpg'
  }
];
